import React from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background: var(--paper);
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 64px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const StyledText = styled.div`
  h2 {
    max-width: 620px;
  }

  p {
    max-width: 560px;
    color: var(--text-soft);
    font-size: var(--fz-lg);
  }
`;

const StyledStats = styled.ul`
  ${({ theme }) => theme.mixins.resetList};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  li {
    padding: 26px 22px;
    border: 1px solid var(--line);
    border-radius: var(--radius-lg);
    background: var(--paper-soft);
    text-align: left;

    strong {
      display: block;
      margin-bottom: 6px;
      color: var(--text);
      font-size: clamp(1.6rem, 3vw, 2.1rem);
      font-weight: 700;
      line-height: 1;
    }

    span {
      color: var(--text-mute);
      font-size: var(--fz-xs);
      line-height: 1.4;
    }
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Positioning = () => (
  <StyledSection id="positioning">
    <StyledInner>
      <StyledText>
        <p className="eyebrow">Что такое SMART-KVADRAT</p>
        <h2>Один специалист — полный цикл работы над IT-продуктом</h2>
        <p>
          SMART-KVADRAT — это профессиональная деятельность Пушкаревой Марии Викторовны:
          разработка программного обеспечения, управление IT-проектами, применение искусственного
          интеллекта и учёт требований информационной безопасности. Вы работаете напрямую со
          специалистом, который отвечает за результат от идеи до запуска.
        </p>
      </StyledText>

      <StyledStats>
        <li>
          <strong>5+</strong>
          <span>лет в разработке ПО и управлении IT-проектами</span>
        </li>
        <li>
          <strong>к.э.н.</strong>
          <span>кандидат экономических наук, доцент ЮУрГУ</span>
        </li>
        <li>
          <strong>6</strong>
          <span>направлений: от сайтов до информационной безопасности</span>
        </li>
      </StyledStats>
    </StyledInner>
  </StyledSection>
);

export default Positioning;
